import { render, staticRenderFns } from "./inputLayout.vue?vue&type=template&id=af1749d6&scoped=true&"
import script from "./inputLayout.vue?vue&type=script&lang=js&"
export * from "./inputLayout.vue?vue&type=script&lang=js&"
import style0 from "./inputLayout.vue?vue&type=style&index=0&id=af1749d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1749d6",
  null
  
)

export default component.exports